module.exports = __webpack_public_path__ + "static/img/配送-act.ac280c32.png";